import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from 'antd'
import styles from './index.module.scss'
import MainContext from '@/stores/stores'
import llq1Png from '@/assets/img/llq1.png'
import llq2Png from '@/assets/img/llq2.png'
import { useIntl } from 'react-intl'

const FooterOne: React.FC<any> = (props) => {
  const { info } = props
  const [config, setConfig] = useState<any>(info.config ? info.config : {})
  const intl = useIntl()
  let lang = localStorage.getItem('lang') || 'zh'
  const navigate = useNavigate()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { userInfo, pageType, isWomala, webData, colorPrimary, logo, fontColorPrimary  } = commonStore

  useEffect(() => {
    setTimeout(() => {
      props.onReady?.()
    },100)
  },[pageType])
  const cexport = () => {
    const origin = window.location.origin || ''
    const allowed = [
      'kangpower.maiqipei.com',
      'www.kangpower.com'
    ]
    const originMatches = allowed.some((s) => origin.includes(s))
    if (originMatches) return true
    if (origin.includes('webtest.maiqipei.com') || origin.includes('300')) return true
    return false
  }
  let otherPage  = pageType === '3' || isWomala ? true : false

  const goto = (url: string) => {
    if(url) {
      window.open(url, "_blank")
    }
  }
  const toHome = () => {
    navigate('/home')
  }
  return (
    <div 
      id="footer"
      className={styles['footer']} 
      style={{ backgroundColor: colorPrimary, color: fontColorPrimary ? fontColorPrimary : '#ffffff' }}
      // style={{ backgroundColor: isWomala  ? '#EDEDED' : '#434343', color: isWomala ? '#000000' : '#ffffff' }}
    >
      <div className={styles['footer-company2']}>
        {
          config.logo ? <div className={styles['logo-img']} onClick={toHome}>
            <img src={config.logo}/>
          </div> : null
        }
        {
          config.phone ? <p className="center flex-c-c">
            <i className="iconfont icon-a-24gf-telephone1 mr5" />
            {config.phone}
          </p> : null
        }
        {
          config.email ? <p className="center  flex-c-c">
            <i className="iconfont icon-a-youxiang11 mr5" />
            {config.email} 
          </p> : null
        }
        <p className="center  flex-c-c" style={{ opacity: .8 }}>
          <span>{config.filings}</span>
          <span style={{ borderBottom: '1px solid #878787', cursor: 'pointer'  }} onClick={() => goto('https://beian.miit.gov.cn')}>{config.filings_no}</span>
        </p>
        {
          commonStore.supportData && commonStore.supportData.show_technical_support ? <p className="center flex-c-c" style={{ fontSize: 12 }}>
            <img className="mr5" src={llq2Png} alt="" />
            <span
              onClick={() => goto('https://www.007vin.com/')} 
              className="pointer" style={{ display: 'inline-block', borderBottom: '1px solid #878787', opacity: .8 }}>
              {intl.formatMessage({ id: '零零汽提供技术支持' })}
            </span>
          </p> : null
        }
        {
          config.qrcode ? <div className={styles['qrcode-img']}>
            <img src={config.qrcode}/>
          </div> : null
        }
      </div>
      {
        cexport() ? <div className='center'>
          Website đang trong thời gian trong thời gian khai báo với Bộ Công Thương
        </div> : null
      }
      
    </div>
  )
}
export default FooterOne